/* eslint-disable max-len */
/* eslint-disable prettier/prettier */

import { PatientUsageReportDto } from '@peartherapeutics/hylia-api-client';

/**
 * This file can be used for unit tests.
 */

export const usageReportInitialState: PatientUsageReportDto = {
  dailySummaries: [
    {
      date: '2022-07-21',
      appointmentCompliance: 'Attended',
      cleanScreenCompliance: 'Positive',
    },
    {
      date: '2022-07-22',
    },
    {
      date: '2022-07-23',
    },
    {
      date: '2022-07-24',
    },
    {
      date: '2022-07-25',
    },
    {
      date: '2022-07-26',
      medicationCompliance: 'No',
    },
    {
      date: '2022-07-27',
      cleanScreenCompliance: 'Positive',
    },
    {
      date: '2022-07-28',
    },
    {
      date: '2022-07-29',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-07-30',
      medicationCompliance: 'No',
    },
    {
      date: '2022-07-31',
    },
    {
      date: '2022-08-01',
    },
    {
      date: '2022-08-02',
    },
    {
      date: '2022-08-03',
      cleanScreenCompliance: 'Negative',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-04',
      appointmentCompliance: 'Attended',
    },
    {
      date: '2022-08-05',
    },
    {
      date: '2022-08-06',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-07',
    },
    {
      date: '2022-08-08',
      cleanScreenCompliance: 'Positive',
    },
    {
      date: '2022-08-09',
    },
    {
      date: '2022-08-10',
      cleanScreenCompliance: 'Negative',
    },
    {
      date: '2022-08-11',
    },
    {
      date: '2022-08-12',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-13',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-14',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-15',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-16',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-17',
      cleanScreenCompliance: 'Positive',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-18',
      appointmentCompliance: 'Attended',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-19',
      medicationCompliance: 'No',
    },
    {
      date: '2022-08-20',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-21',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-22',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-23',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-24',
      cleanScreenCompliance: 'Negative',
    },
    {
      date: '2022-08-25',
    },
    {
      date: '2022-08-26',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-27',
    },
    {
      date: '2022-08-28',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-08-29',
    },
    {
      date: '2022-08-30',
    },
    {
      date: '2022-08-31',
      cleanScreenCompliance: 'Positive',
    },
    {
      date: '2022-09-01',
      appointmentCompliance: 'Attended',
    },
    {
      date: '2022-09-02',
    },
    {
      date: '2022-09-03',
    },
    {
      date: '2022-09-04',
    },
    {
      date: '2022-09-05',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-06',
    },
    {
      date: '2022-09-07',
      cleanScreenCompliance: 'Positive',
    },
    {
      date: '2022-09-08',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-09',
    },
    {
      date: '2022-09-10',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-11',
    },
    {
      date: '2022-09-12',
      medicationCompliance: 'No',
    },
    {
      date: '2022-09-13',
    },
    {
      date: '2022-09-14',
      cleanScreenCompliance: 'Positive',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-15',
      appointmentCompliance: 'Attended',
    },
    {
      date: '2022-09-16',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-17',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-18',
    },
    {
      date: '2022-09-19',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-20',
    },
    {
      date: '2022-09-21',
      cleanScreenCompliance: 'Negative',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-22',
    },
    {
      date: '2022-09-23',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-09-24',
    },
    {
      date: '2022-09-25',
    },
    {
      date: '2022-09-26',
    },
    {
      date: '2022-09-27',
    },
    {
      date: '2022-09-28',
      cleanScreenCompliance: 'Positive',
    },
    {
      date: '2022-09-29',
    },
    {
      date: '2022-09-30',
    },
    {
      date: '2022-10-01',
      appointmentCompliance: 'Attended',
      medicationCompliance: 'Yes',
      cleanScreenCompliance: 'Positive',
      substanceUse: 'Yes',
    },
    {
      date: '2022-10-02',
      appointmentCompliance: 'Absent',
      medicationCompliance: 'No',
      cleanScreenCompliance: 'Negative',
      substanceUse: 'No',
    },
    {
      date: '2022-10-03',
      cleanScreenCompliance: 'Negative',
    },
    {
      date: '2022-10-04',
      cleanScreenCompliance: 'Negative',
    },
    {
      date: '2022-10-05',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-10-06',
      medicationCompliance: 'Yes',
    },
    {
      date: '2022-10-07',
    },
    {
      date: '2022-10-08',
      medicationCompliance: 'No',
    },
    {
      date: '2022-10-09',
    },
    {
      date: '2022-10-10',
    },
    {
      date: '2022-10-11',
      cleanScreenCompliance: 'Negative',
    },
    {
      date: '2022-10-12',
      cleanScreenCompliance: 'Positive',
    },
    {
      date: '2022-10-13',
      cleanScreenCompliance: 'Negative',
    },
    {
      date: '2022-10-14',
    },
    {
      date: '2022-10-15',
    },
    {
      date: '2022-10-16',
    },
    {
      date: '2022-10-17',
    },
    {
      date: '2022-10-18',
    },
    {
      date: '2022-10-19',
    },
  ],
  substanceUseDaysCount: 0,
  substanceUseDaysCountThisMonth: 0,
  medicationUseDaysCountThisMonth: 2,
  medicationNonUses: [
    {
      date: '7/26/2022',
      reasons: [['I totally forgot', '', '']],
    },
    {
      date: '7/29/2022',
      reasons: [['feel tired', '', '']],
    },
    {
      date: '7/30/2022',
      reasons: [["I feel headache and fever so I didn't take", '', '']],
    },
    {
      date: '8/19/2022',
      reasons: [['I forgot totally', '', '']],
    },
    {
      date: '9/12/2022',
      reasons: [['I was tired and forgot to take', '', '']],
    },
    {
      date: '10/8/2022',
      reasons: [['totally forgot', '', '']],
    },
  ],
};
